import React from 'react';

const RutaCard = ({ ruta, index }) => {
  return (
    <div
      className="group relative bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-300 flex flex-col h-full"
      style={{ animationDelay: `${index * 200}ms` }}
    >
      {/* Gradient Background */}
      <div className={`absolute inset-0 bg-gradient-to-br ${ruta.color} opacity-0 group-hover:opacity-10 transition-opacity`}></div>

      {/* Content */}
      <div className="relative p-8 flex-1 flex flex-col">
        <div className="text-5xl mb-4">{ruta.icon}</div>
        <h3 className="text-2xl font-bold text-gray-800 mb-4">{ruta.title}</h3>
        <p className="text-gray-600 mb-6">{ruta.description}</p>

        <div className="mb-6">
          <h4 className="text-sm font-semibold text-gray-700 mb-3">Áreas de formación:</h4>
          <div className="flex flex-wrap gap-2">
            {ruta.skills.map((skill, idx) => (
              <span 
                key={idx}
                className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-red-600 hover:text-white transition-all"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-auto">
          <button className={`group/btn relative px-6 py-3 bg-gradient-to-r ${ruta.color} text-white rounded-full font-semibold overflow-hidden transition-all`}>
            <span className="relative z-10 group-hover/btn:opacity-0 transition-opacity">Explorar Cursos</span>
            <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover/btn:opacity-100 transition-opacity">
              Explorar Cursos →
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RutaCard;
